var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "v-alert-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "v-alert",
        class: [`v-alert--${_vm.type}`],
      },
      [
        _c(
          "div",
          {
            staticClass: "v-alert__main",
            class: [
              _vm.isBigPadding,
              {
                "v-alert__main--center": _vm.alignCenter,
                "v-alert__main--hide-icon": !_vm.showIcon,
              },
            ],
          },
          [
            _c("div", { staticClass: "v-alert__main-inner" }, [
              _vm.title
                ? _c(
                    "div",
                    { staticClass: "v-alert__title", class: [_vm.isBoldTitle] },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "v-alert__description" },
                [
                  _vm._t("default", function () {
                    return [_vm._v(_vm._s(_vm.description))]
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
        _vm.showIcon
          ? _c("div", { staticClass: "v-alert__icon" }, [
              _c("i", {
                staticClass: "v-alert__icon-inner",
                class: [_vm.iconClass, _vm.isBigIcon],
              }),
            ])
          : _vm._e(),
        _c("div", { staticClass: "v-alert__button" }, [
          _vm.showDetailsButton
            ? _c(
                "span",
                {
                  staticClass: "v-alert__show-detail",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("handle-details-click")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm._("查看详情")))]
              )
            : _vm._e(),
          _vm.showClose
            ? _c("span", {
                staticClass: "v-alert__close v-icon-close",
                on: { click: _vm.close },
              })
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }